import { render, staticRenderFns } from "./CollectiveCard.vue?vue&type=template&id=e6c6e37e&scoped=true"
import script from "./CollectiveCard.vue?vue&type=script&lang=js"
export * from "./CollectiveCard.vue?vue&type=script&lang=js"
import style0 from "./CollectiveCard.vue?vue&type=style&index=0&id=e6c6e37e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6c6e37e",
  null
  
)

export default component.exports